
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class SkuHdGrid extends Serenity.EntityGrid<SkuHdRow, any> {
        protected getColumnsKey() { return SkuHdColumns.columnsKey; }
        protected getDialogType() { return SkuHdDialog; }
        protected getIdProperty() { return SkuHdRow.idProperty; }
        protected getInsertPermission() { return SkuHdRow.insertPermission; }
        protected getLocalTextPrefix() { return SkuHdRow.localTextPrefix; }
        protected getService() { return SkuHdService.baseUrl; }

        private _SupplierId: string;
        constructor(container: JQuery) {
            super(container);
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            // new Serenity.AutoColumnWidthMixin({
            //     grid: this
            // });

            return this.slickGrid;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.push({
                title: "Import From Excel",
                hint: "Import Promo from Excel template",
                cssClass: "upload-basicpromo-template-button",
                icon: "fa-cloud-upload-alt",
                separator: true,
                onClick: () => {
                    const dialog = new Common.ImportItemMasterDialog()
                    this.initDialog(dialog)
                    dialog.importState = () => {
                        Q.notifySuccess("Import from Excel successfully.")
                        this.refresh()
                    }
    
                    dialog.dialogOpen()
                }
            })

            buttons.push({
                title: "Download Template",
                hint: "Download Excel template for Product import",
                cssClass: "download-product-template-button",
                icon: "fa-download",
                separator: true,
                onClick: () => {
                    window.location.href = Q.resolveUrl("~/Services/Csi/DownloadImportProduct1Template");
                }
            })

            buttons.push(
                {
                    title: Q.text("Export List"), // *** Get button text from translation 
                    cssClass: 'export-list-button',
                    icon: 'fa-download',
                    onClick: () => {
                        window.location.href = '/Product/ReportExportV1';
                        return false;
                    },
                }
            );    
                buttons.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: SkuHdService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["CustGroupName"]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

         

        

            // var h = Q.tryFirst(CsSkuRow.getLookup().items, x => x.SupplierId != null && x.ActiveFg == 1)
            

            // Q.first(filters, x => x.field == "SupplierId").init = w => {
            //     let stringEditor = w as Serenity.StringEditor;
            //     stringEditor.value = h.SupplierId;
            //     // stringEditor.changeSelect2(e => {

            //     //     this._SupplierId = stringEditor.value ?? this._SupplierId;
            //     //     if (Q.isEmptyOrNull(stringEditor.value)) {
            //     //         Q.notifyError("SupplierId cannot be null.");
            //     //         stringEditor.value = this._SupplierId;
            //     //     }
            //     // });

            // };

        return filters;
        }
    }
}